/* Colouring-book host: guided offers, child details, book choices and cover samples.
   The shared cart adder retains the existing single and bundle contracts. */
(function () {
  'use strict';

  var root = document.querySelector('[data-llcb-root]');
  if (!root) return;
  if (!window.LLBooksOffers || typeof window.LLBooksOffers.requiresSingleChild !== 'function') {
    document.querySelectorAll('[data-llcb-add], [data-llcb-add-sticky]').forEach(function (button) { button.disabled = true; button.textContent = 'Please refresh'; });
    var refreshStatus = root.querySelector('[data-llcb-add-status]');
    if (refreshStatus) { refreshStatus.hidden = false; refreshStatus.textContent = 'Please refresh to load the latest book options.'; }
    return;
  }

  /* The gallery is sticky under the site header, which is sticky itself;
     it needs the header's height as its offset (.llcb__gallery reads
     --llp-sticky-top) — measured, because the header's height depends on
     the announcement bar and the viewport. */
  var siteHeader = document.querySelector('.section-llp-header');
  function syncStickyTop() {
    if (!siteHeader) return;
    root.style.setProperty('--llp-sticky-top', Math.round(siteHeader.getBoundingClientRect().height) + 'px');
  }
  syncStickyTop();
  window.addEventListener('resize', syncStickyTop);

  var configNode = root.querySelector('[data-llcb-config]');
  if (!configNode) return;

  var config;
  try {
    config = JSON.parse(configNode.textContent || '{}');
  } catch (error) {
    return;
  }
  var region = config.region || 'GB';
  var isUS = region === 'US';
  var offersModule = window.LLBooksOffers || null;

  /* ================= gallery ================= */
  var mainImage = root.querySelector('[data-llcb-main-image]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-llcb-thumb]'));
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImage) return;
      mainImage.src = thumb.getAttribute('data-src') || '';
      mainImage.srcset = thumb.getAttribute('data-srcset') || '';
      mainImage.alt = thumb.getAttribute('data-alt') || '';
      thumbs.forEach(function (candidate) {
        candidate.setAttribute('aria-pressed', candidate === thumb ? 'true' : 'false');
      });
    });
  });

  /* ================= state + controls ================= */
  var consentInput = root.querySelector('[data-llcb-consent]');
  var photoInput = root.querySelector('[data-llcb-photo]');
  var photoPreview = root.querySelector('[data-llcb-photo-preview]');
  var photoLabel = root.querySelector('[data-llcb-photo-label]');
  var photoStatus = root.querySelector('[data-llcb-photo-status]');
  var nameInput = root.querySelector('[data-llcb-name]');
  var nameStatus = root.querySelector('[data-llcb-name-status]');
  var coverName = root.querySelector('[data-llcb-cover-name]');
  var addButton = root.querySelector('[data-llcb-add]');
  var addStatus = root.querySelector('[data-llcb-add-status]');
  var state = { photoFile: null, photoDataUrl: null, name: '', offer: 'single', checking: false };
  var journey = null, configurator = null, offerSelector = null;
  var guidedEnabled = Boolean(window.LLStorybookJourney && window.LLBundlePage);
  function syncJourney() { if (journey) journey.sync(); }
  var photoCheck = window.LLPhotoCheck || null;
  var photoCheckGeneration = 0;
  /* The accepted photo's warning verdict (null for a clean photo), kept so a
     consent error that replaces its line can give the warning back. */
  var acceptedPhotoWarning = null;
  /* "Choose another photo": an offer under a photo warning (the photo still
     counts). setStatus() shows it only while the photo status is a warning. */
  var photoRetry = document.createElement('button');
  photoRetry.type = 'button';
  photoRetry.className = 'll-photo-retry';
  photoRetry.setAttribute('data-ll-photo-retry', '');
  photoRetry.hidden = true;
  photoRetry.textContent = 'Choose another photo';
  photoRetry.addEventListener('click', function () {
    photoInput.click();
    if (photoCheck) photoCheck.warmUp();
  });
  if (photoStatus) photoStatus.after(photoRetry);
  var uploadControl = root.querySelector('.llcb__upload');
  var consentControl = root.querySelector('.llcb__photo-consent');
  var PHOTO_READY_COPY = '✓ Lovely — this photo is ready to use.';
  var CONSENT_SUFFIX = ' Tick the box above to continue.';
  var CONSENT_MISSING_COPY = 'Please tick the box above to confirm you have authority to provide this photo.';
  var allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
  var maximumPhotoBytes = 10 * 1024 * 1024;
  var storage = null;
  try { storage = window.localStorage; } catch (error) { /* fail closed before POST */ }
  var pendingKey = 'llcb:' + String(config.product && config.product.handle || 'unknown') + ':pending-add';
  var cartAdder = offersModule && offersModule.createCartAdder ? offersModule.createCartAdder({
    tokenProperty: '_Coloring book add token',
    storageKey: pendingKey,
    storage: storage,
    cartUrl: config.cartUrl || '/cart',
    region: region,
    controls: function () { return [addButton, document.querySelector('[data-llcb-add-sticky]')].filter(Boolean); },
    statusNode: addStatus,
    idleLabel: config.ctaLabel || ('Personalise & add to ' + basketWord()),
    tokenPrefix: 'coloring',
    available: function () { return Boolean(config.product && config.product.available); }
  }) : null;

  function setStatus(node, message, kind) {
    if (!node) return;
    node.hidden = !message;
    node.className = 'llsb__upload-status' + (kind ? ' is-' + kind : '');
    node.textContent = message || '';
    if (node === photoStatus) photoRetry.hidden = !(kind === 'warn' && Boolean(message));
  }

  function validName(value) {
    if (offersModule && offersModule.validName) return offersModule.validName(value);
    var normalized = String(value || '').trim();
    if (!normalized) return false;
    try {
      return /\p{Script=Latin}/u.test(normalized)
        && /^[\p{Script=Latin}\p{M} '’ʼ\-‐]+$/u.test(normalized);
    } catch (error) {
      return /^[A-Za-zÀ-ž '’ʼ\-‐]+$/.test(normalized);
    }
  }

  /* One word, one owner: ll-books-offers.js maps region -> "cart"/"basket".
     The inline fallback keeps the page correct if that module has not loaded
     and must never drift back to a hard-coded "basket". */
  function basketWord(capitalised) {
    var word = (offersModule && offersModule.basketWord)
      ? offersModule.basketWord(region)
      : (isUS ? 'cart' : 'basket');
    return capitalised ? word.charAt(0).toUpperCase() + word.slice(1) : word;
  }

  function possessiveName(value) {
    var name = String(value || '').trim();
    return name ? name + "'s" : "Their name's";
  }

  function updateName() {
    var next = nameInput ? nameInput.value.trim() : '';
    if (String.prototype.normalize) next = next.normalize('NFC');
    state.name = next;
    if (coverName) coverName.textContent = possessiveName(next);
    var invalid = Boolean(next) && !validName(next);
    if (nameInput) {
      nameInput.setCustomValidity(invalid ? 'Please use Latin letters, spaces, apostrophes and hyphens.' : '');
      if (invalid) nameInput.setAttribute('aria-invalid', 'true');
      else nameInput.removeAttribute('aria-invalid');
    }
    setStatus(nameStatus, invalid ? 'Please use Latin letters, spaces, apostrophes and hyphens.' : '', invalid ? 'bad' : '');
    syncJourney();
  }

  function resetPhoto(message) {
    photoCheckGeneration++;
    acceptedPhotoWarning = null;
    state.checking = false;
    state.photoFile = null;
    state.photoDataUrl = null;
    if (photoPreview) {
      photoPreview.removeAttribute('src');
      photoPreview.hidden = true;
    }
    if (photoLabel) photoLabel.textContent = 'Upload their photo';
    setStatus(photoStatus, message || '', message ? 'bad' : '');
    syncJourney();
  }

  /* verdict: the ll-photo-check.js result for this upload (null when the
     gate is not loaded). A warn-level verdict keeps its own amber copy so
     the shopper can weigh it; ok and fail-open both read as ready. */
  function acceptPhoto(file, dataUrl, width, height, verdict) {
    state.checking = false;
    state.photoWidth = width; state.photoHeight = height;
    state.photoFile = file;
    state.photoDataUrl = dataUrl;
    if (photoPreview) {
      photoPreview.src = dataUrl;
      photoPreview.hidden = false;
    }
    if (photoLabel) photoLabel.textContent = 'Choose another photo';
    if (uploadControl) uploadControl.classList.remove('is-missing');
    var permission = consentInput && consentInput.checked;
    var warn = Boolean(verdict && verdict.level === 'warn');
    acceptedPhotoWarning = warn ? { message: verdict.message } : null;
    setStatus(
      photoStatus,
      (warn ? verdict.message : PHOTO_READY_COPY) + (permission ? '' : CONSENT_SUFFIX),
      warn ? 'warn' : 'ok'
    );
    syncJourney();
  }

  /* Start fetching the detector as soon as the shopper reaches for the
     upload control — the file picker's own delay hides the download. */
  if (uploadControl && photoCheck) {
    uploadControl.addEventListener('click', function () { photoCheck.warmUp(); });
  }

  if (photoInput) {
    photoInput.addEventListener('change', function () {
      var file = photoInput.files && photoInput.files[0];
      if (!file) return;
      if (allowedTypes.indexOf(file.type) === -1) {
        resetPhoto('Please choose a JPEG, PNG or WebP image.');
        photoInput.value = '';
        return;
      }
      if (file.size > maximumPhotoBytes) {
        resetPhoto('Please choose an image smaller than 10 MB.');
        photoInput.value = '';
        return;
      }
      resetPhoto();
      state.checking = true;
      setStatus(photoStatus, 'Checking photo…', '');
      syncJourney();
      var generation = ++photoCheckGeneration;
      var reader = new FileReader();
      reader.onerror = function () { if (generation === photoCheckGeneration) resetPhoto('We couldn’t read that image. Please choose another.'); };
      reader.onload = function () {
        var probe = new Image();
        probe.onerror = function () { if (generation === photoCheckGeneration) resetPhoto('We couldn’t read that image. Please choose another.'); };
        probe.onload = function () {
          if (generation !== photoCheckGeneration) return;
          if (probe.naturalWidth < 500 || probe.naturalHeight < 500) {
            resetPhoto('That photo is too small. Please choose a clear image at least 500 × 500px.');
            photoInput.value = '';
            return;
          }
          /* In-browser face gate (ll-photo-check.js): a block-level verdict
             refuses the photo with its own copy; the detector being
             unavailable resolves to ok, so this degrades to the size check.
             With no checker at all (the script failed to load), or one that
             throws or rejects anyway, the photo goes ahead unchecked (owner,
             2026-10-28). */
          var verdictPromise = new Promise(function (done) { done(photoCheck ? photoCheck.check(probe) : { level: 'ok', code: 'unchecked' }); })
            .catch(function () { return { level: 'ok', code: 'unchecked' }; });
          verdictPromise.then(function (verdict) {
            if (generation !== photoCheckGeneration) return;
            if (verdict && verdict.level === 'block') {
              resetPhoto(verdict.message);
              photoInput.value = '';
              return;
            }
            acceptPhoto(file, String(reader.result || ''), probe.naturalWidth, probe.naturalHeight, verdict);
          }).catch(function () { if (generation === photoCheckGeneration) resetPhoto('We couldn’t check that photo. Please try again.'); });
        };
        probe.src = String(reader.result || '');
      };
      reader.readAsDataURL(file);
    });
  }

  if (consentInput) {
    consentInput.addEventListener('change', function () {
      if (consentControl) consentControl.classList.remove('is-missing');
      if (photoStatus && photoStatus.textContent === CONSENT_MISSING_COPY) setStatus(photoStatus, '', '');
      if (state.photoFile && photoStatus && !photoStatus.hidden && /is-(ok|warn)/.test(photoStatus.className)) {
        var kind = /is-warn/.test(photoStatus.className) ? 'warn' : 'ok';
        var base = photoStatus.textContent.replace(CONSENT_SUFFIX, '');
        setStatus(photoStatus, base + (consentInput.checked ? '' : CONSENT_SUFFIX), kind);
      } else if (state.photoFile && acceptedPhotoWarning) {
        /* a consent error replaced the photo's own warning; give it back */
        setStatus(photoStatus, acceptedPhotoWarning.message + (consentInput.checked ? '' : CONSENT_SUFFIX), 'warn');
      } else if (state.photoFile) {
        setStatus(photoStatus, PHOTO_READY_COPY + (consentInput.checked ? '' : CONSENT_SUFFIX), 'ok');
      }
      syncJourney();
    });
  }
  if (nameInput) nameInput.addEventListener('input', updateName);
  updateName();

  function ready() {
    return Boolean(
      config.product
      && config.product.available
      && config.product.variantId
      && config.storyId
      && state.photoFile && !state.checking
      && consentInput
      && consentInput.checked
      && validName(state.name)
    );
  }

  function firstMissing() {
    if (!state.photoFile) return { node: photoInput, message: 'Please upload their photo first.', status: photoStatus, control: uploadControl };
    if (!consentInput || !consentInput.checked) return { node: consentInput, message: CONSENT_MISSING_COPY, status: photoStatus, control: consentControl };
    if (!state.name) return { node: nameInput, message: 'Please enter the child’s first name.', status: nameStatus };
    if (!validName(state.name)) return { node: nameInput, message: 'Please check the child’s name.', status: nameStatus };
    return null;
  }

  function guideToMissing() {
    var missing = firstMissing();
    if (!missing) return false;
    setStatus(missing.status, missing.message, 'bad');
    if (missing.control) missing.control.classList.add('is-missing');
    var target = missing.node && missing.node.closest ? missing.node.closest('.llcb__step') : null;
    if (target) target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    if (missing.node && typeof missing.node.focus === 'function') missing.node.focus({ preventScroll: true });
    return true;
  }

  /* ================= arrival estimate ================= */
  /* The story pages' estimate, the 8th to 10th working day, so a colouring
     book and a story bought together promise the same window. Without the
     journey script it falls back to the buffered worst case of 9 working
     days. Client-side because storefront pages are cached. */
  function renderArrivalEstimate() {
    var nodes = document.querySelectorAll('[data-llcb-arrival]');
    if (!nodes.length) return;
    var core = window.LLStorybookJourney && window.LLStorybookJourney.core;
    var range = '';
    try { if (core && core.arrivalRange) range = core.arrivalRange(new Date()); } catch (error) { range = ''; }
    if (range) {
      Array.prototype.forEach.call(nodes, function (node) { node.textContent = 'Estimated arrival: ' + range; });
      return;
    }
    var WORKING_DAYS = 9;
    var date = new Date();
    var added = 0;
    while (added < WORKING_DAYS) {
      date.setDate(date.getDate() + 1);
      var weekday = date.getDay();
      if (weekday !== 0 && weekday !== 6) added += 1;
    }
    var label;
    try {
      label = new Intl.DateTimeFormat(isUS ? 'en-US' : 'en-GB', { weekday: 'short', day: 'numeric', month: 'short' }).format(date);
    } catch (error) {
      return;
    }
    Array.prototype.forEach.call(nodes, function (node) { node.textContent = 'Arrives by ' + label; });
  }

  /* ================= mobile buy bar ================= */
  var ctabar = root.querySelector('[data-llcb-ctabar]');
  if (ctabar) {
    document.body.appendChild(ctabar);
    ctabar.hidden = false;
  }
  (function observeInlineBuyBlockForCtaBar() {
    if (guidedEnabled || !ctabar || typeof IntersectionObserver !== 'function') return;
    var buyBlock = root.querySelector('.llcb__buy');
    if (!buyBlock) return;
    var VISIBLE_RATIO = 0.4;
    var appliedHidden = false;
    var toggleTimer = null;
    var observer = new IntersectionObserver(function (entries) {
      var inlineCtaOnScreen = entries[0].intersectionRatio >= VISIBLE_RATIO;
      if (toggleTimer) { window.clearTimeout(toggleTimer); toggleTimer = null; }
      if (inlineCtaOnScreen === appliedHidden) return;
      toggleTimer = window.setTimeout(function () {
        appliedHidden = inlineCtaOnScreen;
        ctabar.hidden = appliedHidden;
        toggleTimer = null;
      }, 120);
    }, { threshold: [0, VISIBLE_RATIO] });
    observer.observe(buyBlock);
  }());
  /* keeps the fixed buy bar clear of Shopify's privacy banner — shared with
     the bundle page via ll-books-offers.js (LLBooksOffers.trackConsentClearance) */
  if (offersModule && offersModule.trackConsentClearance) offersModule.trackConsentClearance(ctabar);
  renderArrivalEstimate();

  /* ================= offer popup ================= */
  var modal = root.querySelector('[data-llcb-modal]');
  var modalPanel = root.querySelector('[data-llcb-modal-panel]');
  var modalCardsEl = root.querySelector('[data-llcb-offer-cards]');
  var modalCloseButtons = modal ? modal.querySelectorAll('[data-llcb-modal-close]') : null;
  var modalNameEl = root.querySelector('[data-llcb-modal-name]');
  var modalOpener = null;
  var modalCloseTimer = null;

  function modalFocusable() {
    if (!modalPanel) return [];
    return Array.prototype.slice.call(modalPanel.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])')).filter(function (node) {
      return node.offsetParent !== null || node.getClientRects().length > 0;
    });
  }

  function showModalView(name) {
    var views = modal ? modal.querySelectorAll('[data-llcb-modal-view]') : [];
    Array.prototype.forEach.call(views, function (view) {
      view.hidden = view.getAttribute('data-llcb-modal-view') !== name;
    });
    if (modalPanel) {
      modalPanel.classList.toggle('is-wide', name === 'offers' && modalCardsEl && modalCardsEl.children.length >= 3);
      modalPanel.scrollTop = 0;
    }
  }

  /* Scroll lock, iOS-safe. body{overflow:hidden} (the old lock) is simply
     ignored by iOS Safari, so the page kept scrolling behind the popup and a
     phone reader could lose the panel entirely. position:fixed is the only
     lock that engine honours, and it collapses the page to the top unless the
     offset is stored and put back on close — hence the stored scrollY.
     The rule itself lives in ll-books-offers.css (body.llsb-modal-open). */
  var lockedScrollY = 0;

  function lockPageScroll() {
    /* Never re-read the offset while already locked: the page reports scrollY
       0 once body is position:fixed, which would strand the reader at the top
       of the document on close. */
    if (document.body.classList.contains('llsb-modal-open')) return;
    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    document.body.style.top = (-lockedScrollY) + 'px';
    document.body.classList.add('llsb-modal-open');
  }

  function unlockPageScroll() {
    if (!document.body.classList.contains('llsb-modal-open')) return;
    document.body.classList.remove('llsb-modal-open');
    document.body.style.top = '';
    window.scrollTo(0, lockedScrollY);
  }

  function openOfferModal(opener) {
    if (!modal || !modalPanel) return;
    modalOpener = opener || document.activeElement;
    window.clearTimeout(modalCloseTimer);
    /* Same reasoning as the storybook page's sticky-bar reparent: any ancestor
       that ever picks up a transform/filter/will-change turns this
       position:fixed overlay into a position:absolute box inside the page.
       Moving the popup to <body> on first open removes the possibility
       outright. Every node inside it was captured at boot, so the move costs
       nothing else. */
    if (modal.parentNode !== document.body) document.body.appendChild(modal);
    modal.hidden = false;
    lockPageScroll();
    window.requestAnimationFrame(function () {
      modal.classList.add('is-open');
      var targets = modalFocusable();
      if (targets.length) targets[0].focus();
    });
  }

  function closeOfferModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    unlockPageScroll();
    modalCloseTimer = window.setTimeout(function () {
      modal.hidden = true;
      if (modalOpener && typeof modalOpener.focus === 'function') modalOpener.focus();
    }, 180);
  }

  if (modal) {
    if (modalCloseButtons) Array.prototype.forEach.call(modalCloseButtons, function (btn) { btn.addEventListener('click', closeOfferModal); });
    modal.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeOfferModal();
        return;
      }
      if (event.key !== 'Tab') return;
      var targets = modalFocusable();
      if (!targets.length) return;
      var first = targets[0];
      var last = targets[targets.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function primaryChild() {
    return { id: 'primary', name: state.name, photoFile: state.photoFile, photoDataUrl: state.photoDataUrl,
      photoWidth: state.photoWidth, photoHeight: state.photoHeight, consent: Boolean(consentInput && consentInput.checked),
      checking: state.checking, ready: Boolean(state.photoFile) && !state.checking };
  }
  function busy() { return Boolean(addingWithProof || (cartAdder && (cartAdder.isAdding() || cartAdder.pending())) || (configurator && configurator.busy())); }
  function currentBundle() { return pageBundles().filter(function (b) { return b.id === state.offer; })[0] || null; }
  function addLabel() { return 'Add ' + (currentBundle() ? (currentBundle().kind === 'mixed' ? 'set' : 'bundle') : 'book') + ' to ' + basketWord(); }
  function mountConfigurator(bundle) {
    return window.LLBundlePage.mount(root, {
      config: config, bundle: bundle, offers: offersModule, fromStoryId: config.storyBookId,
      primary: { read: primaryChild, guide: guideToMissing },
      guided: { children: function () { return journey ? journey.children() : [primaryChild()]; },
        recipients: function () { return journey ? journey.recipients() : []; },
        assign: function (index, id) { if (journey) journey.assign(index, id); } },
      cta: { buttons: [addButton, document.querySelector('[data-llcb-add-sticky]')], status: addStatus,
        idleLabel: addLabel, storageKey: 'llcb:' + config.product.handle + ':bundle-pending-add', storage: storage },
      trackContext: { region: region, surface: 'colouring', offerId: bundle.id, placement: 'builder' },
      onAdded: function () { if (journey) journey.clear(); }, onChange: syncJourney
    });
  }
  function selectOffer(id) {
    if (busy()) return;
    var bundle = pageBundles().filter(function (b) { return b.id === id && b.available; })[0];
    state.offer = bundle ? id : 'single';
    if (bundle) {
      if (!configurator) configurator = mountConfigurator(bundle);
      else if (configurator.bundle().id !== bundle.id) configurator.setBundle(bundle);
    }
    if (offerSelector) offerSelector.select(state.offer);
    syncJourney();
  }
  if (offersModule && offersModule.bindOfferSelector) offerSelector = offersModule.bindOfferSelector(root, {
    region: region, surface: 'colouring', bundles: pageBundles(), isReady: ready,
    onSelect: guidedEnabled ? selectOffer : function (id) {
      var bundle = pageBundles().filter(function (b) { return b.id === id; })[0];
      if (bundle) chooseBundle(bundle, 'summary');
    }
  });

  function renderCover(container, book) {
    // A single cover is independent of bundle availability and cart recovery.
    if (state.offer === 'single') {
      var cover = config.colouringCovers && config.colouringCovers[book.storyId];
      if (!cover) return Promise.reject(new Error('Cover unavailable'));
      container.textContent = '';
      var tile = document.createElement('figure'); tile.className = 'llbp-tile llbp-tile--colouring';
      var art = document.createElement('img'); art.src = cover.bg; art.alt = book.title; art.width = 680; art.height = 880; tile.appendChild(art);
      var name = document.createElement('span'); name.className = 'llbp-tile__name llbp-tile__name--colouring';
      name.textContent = offersModule.possessive(book.child.name);
      name.style.cssText = 'left:' + cover.box.x + '%;top:' + cover.box.y + '%;width:' + cover.box.w + '%;height:' + cover.box.h + '%;text-align:center;';
      name.style.color = cover.style.color; name.style.fontFamily = cover.style.family; name.style.fontWeight = String(cover.style.weight);
      name.style.letterSpacing = cover.style.tracking + 'em'; name.style.lineHeight = String(cover.style.leading || 1);
      tile.appendChild(name); container.appendChild(tile);
      var fitName = function () { name.style.fontSize = window.LLBundlePage.core.coverNameFontPx(cover.style, name.clientWidth, name.clientHeight, name.textContent, tile.clientHeight) + 'px'; };
      fitName(); art.addEventListener('load', fitName);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitName);
    } else configurator.previewBook(container, book);
    return Promise.all(Array.prototype.map.call(container.querySelectorAll('img'), function (img) {
      return new Promise(function (resolve, reject) {
        if (img.complete) { if (img.naturalWidth) resolve(); else reject(new Error('Cover unavailable')); return; }
        var timer = setTimeout(function () { reject(new Error('Cover timed out')); }, 15000);
        img.onload = function () { clearTimeout(timer); resolve(); };
        img.onerror = function () { clearTimeout(timer); reject(new Error('Cover unavailable')); };
      });
    }));
  }

  function confirmLabel() {
    return 'Confirm & add to ' + basketWord();
  }

  function pageBundles() {
    /* A colouring page sells the colouring double only: the story bundles,
       Their Complete Collection among them, belong to the story pages. */
    return (config.bundles || []).filter(function (bundle) { return bundle && bundle.kind === 'colouring'; });
  }

  function buildOfferCards() {
    if (!modalCardsEl) return;
    modalCardsEl.textContent = '';
    if (modalNameEl) modalNameEl.textContent = state.name || 'your child';
    var offers = config.offers || [];
    offers.forEach(function (offer) {
      var card = document.createElement('article');
      card.className = 'llsb-offer';
      card.setAttribute('data-llcb-offer', offer.id);
      var visual = document.createElement('div');
      visual.className = 'llsb-offer__visual';
      var mockup = document.createElement('div');
      mockup.className = 'llsb-offer__mockup';
      mockup.setAttribute('role', 'img');
      mockup.setAttribute('aria-label', (isUS ? 'Personalized coloring book' : 'Personalised colouring book') + ' mockup');
      var base = document.createElement('img');
      base.className = 'llsb-offer__mockup-base';
      base.alt = '';
      base.decoding = 'async';
      if (config.product && config.product.image) base.src = config.product.image;
      mockup.appendChild(base);
      visual.appendChild(mockup);
      card.appendChild(visual);
      var name = document.createElement('h3');
      name.className = 'llsb-offer__name';
      /* the single card is titled for the child ("Sam's Colouring
         Adventure"); the story it is based on moves into the subtitle */
      name.textContent = offersModule && offersModule.bundleTitle
        ? offersModule.bundleTitle(offer, state.name)
        : offer.title;
      card.appendChild(name);
      if (offer.subtitle) {
        var sub = document.createElement('p');
        sub.className = 'llsb-offer__sub';
        sub.textContent = offer.subtitle;
        card.appendChild(sub);
      }
      var priceNode = offersModule && offersModule.priceBlock
        ? offersModule.priceBlock(offer)
        : (function () { var p = document.createElement('p'); p.className = 'llsb-offer__price'; p.textContent = offer.priceFormatted; return p; }());
      var confirm = document.createElement('button');
      confirm.type = 'button';
      confirm.className = 'llp-btn llsb-offer__confirm llsb-modal__confirm';
      if (offer.available) {
        confirm.textContent = confirmLabel();
        confirm.addEventListener('click', function () { confirmOffer(offer); });
      } else {
        confirm.textContent = 'Sold out';
        confirm.disabled = true;
      }
      if (offersModule && offersModule.foot) {
        card.appendChild(offersModule.foot(priceNode, confirm));
      } else {
        card.appendChild(priceNode);
        card.appendChild(confirm);
      }
      modalCardsEl.appendChild(card);
    });
    if (offersModule) {
      offersModule.renderBundleCards(modalCardsEl, {
        region: region,
        catalogue: config.catalogue,
        bundles: pageBundles(),
        childName: state.name,
        recommendedId: 'two-colouring',
        pageStoryId: config.storyBookId || null,
        onChoose: chooseBundle
      });
    }
    if (offersModule && offersModule.compactSelect) offersModule.compactSelect(modalCardsEl, modal && modal.querySelector('[data-llcb-modal-foot]'), { preselectId: offersModule.requestedBundleId ? offersModule.requestedBundleId() : '' });
    var count = modalCardsEl.children.length;
    modalCardsEl.classList.toggle('is-single', count === 1);
    modalCardsEl.classList.toggle('is-triple', count >= 3);
  }

  /* A bundle card sends the shopper to the bundle product page, carrying
     the child personalised here (photo + name + consent) through the
     offers module's short-lived handoff record; the page personalises the
     rest of the set. */
  function chooseBundle(bundle, placement) {
    if (offersModule && offersModule.trackOffer && placement !== 'summary') offersModule.trackOffer('selected', { region: config.region, surface: 'colouring', offerId: bundle.id, placement: 'popup' });
    if (!offersModule || !offersModule.handoffToBundlePage) return;
    closeOfferModal();
    offersModule.handoffToBundlePage(bundle, {
      storyId: config.storyBookId || '',
      child: { name: state.name, photoFile: state.photoFile }
    });
  }

  /* Offers with storybooks continue on this story's own product page, whose
     journey previews every spread with the child in place (this page only
     has the colouring reader). Whatever the shopper already typed or chose
     travels with them through the offers module's handoff record. */
  function handoffStories(offerId) {
    var core = window.LLStorybookJourney && window.LLStorybookJourney.core;
    var story = ((config.catalogue && config.catalogue.stories) || []).filter(function (s) { return s.storyId === config.storyBookId; })[0];
    if (!core || !story || !story.url) return;
    if (offersModule && offersModule.trackOffer) offersModule.trackOffer('selected', { region: config.region, surface: 'colouring', offerId: offerId, placement: 'selector' });
    var url = core.storyHandoffUrl(story.url, offerId);
    var saved = Promise.resolve();
    if (offersModule && offersModule.createHandoffStore && offersModule.indexedDbHandoffDriver && offersModule.handoffRecord && (state.name || state.photoFile)) {
      try {
        saved = offersModule.createHandoffStore(offersModule.indexedDbHandoffDriver())
          .save(offersModule.handoffRecord({ bundle: { id: offerId }, storyId: config.storyId || '', child: { name: state.name, photoFile: state.photoFile } }));
      } catch (e) { saved = Promise.resolve(); }
    }
    saved.catch(function () {}).then(function () { window.location.href = url; });
  }

  function confirmOffer(offer) {
    if (!offer || !offer.available) return;
    if (offersModule && offersModule.trackOffer) offersModule.trackOffer('selected', { region: config.region, surface: 'colouring', offerId: 'single', placement: 'popup' });
    closeOfferModal();
    addToBasket(null);
  }

  function handleCtaClick(event) {
    if (!cartAdder) {
      setStatus(addStatus, 'Sorry — this page didn’t finish loading. Please refresh and try again.', 'bad');
      return;
    }
    if (cartAdder.pending()) {
      cartAdder.reconcile();
      return;
    }
    if (journey) {
      if (!journey.canSubmit()) { journey.next(); return; }
      if (offersModule && offersModule.trackOffer) offersModule.trackOffer('completed', { region: region, surface: 'colouring', offerId: state.offer, placement: 'builder' });
      if (currentBundle()) { configurator.add(); return; }
      addToBasket(null); return;
    }
    if (cartAdder.isAdding() || guideToMissing() || !ready()) return;
    if (offersModule && offersModule.trackOffer) offersModule.trackOffer('completed', { region: config.region, surface: 'colouring', offerId: 'single', placement: 'builder' });
    buildOfferCards();
    showModalView('offers');
    openOfferModal(event.currentTarget);
  }

  /* ================= add to basket ================= */
  /* order === null adds this colouring book; a bundle order (from the
     configurator) adds the bundle product with the storybook-bundle-v1
     properties instead. Both share the token, reconcile and redirect via
     the shared cartAdder (ll-books-offers.js createCartAdder). */
  function addToBasket(order) {
    if (!cartAdder) {
      setStatus(addStatus, 'Sorry — this page didn’t finish loading. Please refresh and try again.', 'bad');
      return;
    }
    if (cartAdder.pending()) { cartAdder.reconcile(); return; }
    if (cartAdder.isAdding() || addingWithProof || guideToMissing() || !ready()) return;
    var form = new FormData();
    form.append('id', String(order ? order.variantId : config.product.variantId));
    form.append('quantity', '1');
    if (order) {
      order.properties.forEach(function (entry) {
        if (entry.length === 3) form.append('properties[' + entry[0] + ']', entry[1], entry[2]);
        else form.append('properties[' + entry[0] + ']', entry[1]);
      });
    } else {
      form.append('properties[_Story ID]', config.storyId);
      form.append('properties[Child name]', state.name);
      form.append('properties[_Customer photo]', state.photoFile, state.photoFile.name);
    }
    form.append('properties[Personalisation]', 'From your photo');
    form.append('properties[_Photo consent]', 'adult-authority-v2026-07-21');
    var submit = function () {
      addingWithProof = false;
      cartAdder.add(form, { onAdded: function () {
        if (journey) journey.clear();
        if (!order && offersModule && offersModule.trackOffer) offersModule.trackOffer('confirmed', { region: config.region, surface: 'colouring', offerId: 'single', placement: journey ? 'builder' : 'popup' });
      } });
      syncJourney();
    };
    /* A single colouring book travels with its named cover, the same proof
       the bundle lines already carry, so the basket, drawer and mini-cart
       show "Ava's Colouring Adventure" rather than the catalogue sample.
       The bundle module owns the compositor; a missing module or a slow
       render (its own 4 s cap) simply adds the line without the picture. */
    if (!order && window.LLBundlePage && typeof window.LLBundlePage.coverProof === 'function' && config.colouringCovers) {
      addingWithProof = true;
      cartAdder.setControls(true, 'Adding…');
      syncJourney();
      Promise.resolve().then(function () {
        // covers are keyed by the story book (luna_the_shy_dragon), not the colouring story id (dragon_roar)
        return window.LLBundlePage.coverProof(config, { kind: 'colouring' }, { storyId: config.storyBookId || config.storyId, child: { name: state.name } });
      }).then(function (proof) {
        if (proof) form.append('properties[_Personalised artwork]', proof, 'colouring-cover.jpg');
      }).catch(function () {}).then(submit);
      return;
    }
    submit();
  }
  var addingWithProof = false;

  if (addButton) addButton.addEventListener('click', handleCtaClick);
  var stickyAdd = document.querySelector('[data-llcb-add-sticky]');
  if (stickyAdd) stickyAdd.addEventListener('click', handleCtaClick);
  if (guidedEnabled) {
    journey = window.LLStorybookJourney.mount(root, {
      config: config, offer: function () { return state.offer; }, select: selectOffer,
      bundle: function () { return configurator; }, primary: primaryChild, guidePrimary: guideToMissing,
      busy: busy, addLabel: addLabel, buttons: function () { return [addButton, stickyAdd].filter(Boolean); },
      renderCover: renderCover, cancelPreview: function () {}, previewVisibility: function () {},
      handoffStories: handoffStories
    });
    if (journey) journey.start();
  }
  if (cartAdder && cartAdder.pending()) cartAdder.reconcile();

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    if (cartAdder) {
      cartAdder.reset();
      if (cartAdder.pending()) cartAdder.reconcile();
    }
  });
}());
